// Dynamic server configuration
const getServerUrl = () => {
  // In development, use local backend server
  if (process.env.NODE_ENV === "development") {
    return "http://localhost:3001";
  }

  // In production, use environment variable or default
  // return "https://teamgrid.ai";
  return window.location.origin;
};

// Server paths configuration
const getServerPaths = () => {
  const baseUrl = getServerUrl();

  return {
    // Main server URL
    SERVER_URL: baseUrl,

    // API base URL

    API_URL: `${baseUrl}/api/v1`,

    // Images and screenshots server path
    IMAGES_SERVER_URL: "https://teamgrid.ai/team-grid-node-js/server",

    // Uploads path
    UPLOADS_PATH: "/uploads",

    // Screenshots path
    SCREENSHOTS_PATH: "/uploads/screenshots",
  };
};

export const SERVER_URL = getServerUrl();
export const SERVER_PATHS = getServerPaths();

// Helper function to construct image URLs
export const getImageUrl = (fileUrl) => {
  if (!fileUrl) {
    console.warn("🚨 getImageUrl called with null/undefined fileUrl");
    return null;
  }

  // If it's already a full URL, return as is
  if (fileUrl.startsWith("http")) {
    console.log("🔗 Using absolute URL:", fileUrl);
    return fileUrl;
  }

  // Get server paths configuration
  const paths = getServerPaths();

  // Use the images server URL for both development and production
  const baseUrl = `${paths.IMAGES_SERVER_URL}${fileUrl}`;
  const cacheBuster = `?v=${Date.now()}`;
  const fullUrl = `${baseUrl}${cacheBuster}`;
  console.log("🔗 Constructed URL with cache buster:", fullUrl);
  return fullUrl;
};

// Helper function specifically for screenshots
export const getScreenshotUrl = (fileUrl) => {
  return getImageUrl(fileUrl);
};

// Helper function to get the images server base URL
export const getImagesServerUrl = () => {
  return getServerPaths().IMAGES_SERVER_URL;
};

// Export API configuration
export const API_CONFIG = {
  baseURL: SERVER_URL,
  timeout: 120000, // Increased to 2 minutes for complex queries
  headers: {
    "Content-Type": "application/json",
  },
};

const serverConfig = {
  SERVER_URL,
  SERVER_PATHS,
  getImageUrl,
  getScreenshotUrl,
  getImagesServerUrl,
  API_CONFIG,
};

export default serverConfig;
